import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-binnacle-skeleton',
  templateUrl: './binnacle-skeleton.component.html',
  styleUrls: ['./binnacle-skeleton.component.scss']
})
export class BinnacleSkeletonComponent implements OnInit {
  readonly dataSource: number[] = Array(12).fill(0); // Crea un array de 11 elementos
  readonly displayedColumns: string[] = [
    'Visibilidad cliente',
    'Cliente',
    'Fecha de ejecución Inicio - Fin',
    'Estado',
    'Rutina',
    'Categoría',
    'Acuerdos/Pendientes',
    'acciones',
  ];
  constructor() {
  }

  ngOnInit() {
  }

}
